import React from 'react';
import { IProductTexture } from '../../../../entities-generated/common/product-texture';
import { TextureSelector } from '../../../components/texture-selector';

interface IProductVariantSelectorProps {
  swatchSize: number,
  options: IProductTexture[];
  maxOptionDisplay?: number | undefined;
  selected?: IProductTexture | null | undefined;
  showLabels: boolean;
  onSelectionChanged?: (selected: IProductTexture | null) => void;
  rootStyle?: React.CSSProperties | undefined;
}

const getSwatchKey = (option: IProductTexture) => option.id;

const getColorOrImage = (option: IProductTexture) => option.swatchUrl;

const getValue = (option: IProductTexture) => option;

const getLabel = (option: IProductTexture) => option.name;

export const ProductVariantSelector: React.FunctionComponent<IProductVariantSelectorProps> = (props) => {
  const selected = !!props.selected ? [props.selected] : [];

  const onSelectionChanged = (selection: IProductTexture[]) => {
    if(!props.onSelectionChanged) { return; }

    const s = selection.length > 0 ? selection[0] : null;
    props.onSelectionChanged(s);
  }

  return (
    <TextureSelector<IProductTexture, IProductTexture>
      swatchSize={props.swatchSize}
      options={props.options}
      selected={selected}
      showLabels={props.showLabels}
      maxOptionDisplay={props.maxOptionDisplay}
      onSelectionChanged={onSelectionChanged}
      rootStyle={props.rootStyle}
      allowMultipleSelection={false}
      allowNoSelection={false}
      getSwatchKey={getSwatchKey}
      getColorOrImage={getColorOrImage}
      getValue={getValue}
      getLabel={getLabel}
    />
  );
};